import $ from "jquery";
import jQuery from "jquery";

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

import {forEach} from './helpers/forEach';
import Swiper from 'swiper/dist/js/swiper.min';
import Colcade from 'colcade/colcade';
import GLightbox from 'glightbox';
// // set CSRF token for every AJAX request using jquery.cookie
// require('jquery.cookie');
// $.ajaxSetup({ headers: { 'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN') } });


require('jquery-parallax.js');

audiojs.events.ready(function () {
    var audios = document.getElementsByTagName('audio');
    forEach(audios, function (audio) {
        audiojs.create(audio, {
            css: false,
            createPlayer: {
                markup: '<div class="row align-items-center"> <div class="col-auto"> <div class="play-pause"> <p class="play"></p> <p class="pause"></p> <p class="loading"></p> <p class="error"></p> </div> </div> <div class="col"> <div class="scrubber"> <div class="progress"></div> <div class="loaded"></div> </div> </div> <div class="col-auto"> <div class="time"> <span class="played">00:00</span> /  <span class="duration">00:00</span> </div> <div class="error-message"></div> </div> </div>',
                playPauseClass: 'play-pause',
                scrubberClass: 'scrubber',
                progressClass: 'progress',
                loaderClass: 'loaded',
                timeClass: 'time',
                durationClass: 'duration',
                playedClass: 'played',
                errorMessageClass: 'error-message',
                playingClass: 'playing',
                loadingClass: 'loading',
                errorClass: 'error'
            }
        });
    });
});


/*
 * Swiper slider
 */

new Swiper('.swiper-container', {
    loop: true,
    autoplay: {
        delay: 3000,
    },
    pagination: {
        el: '.swiper-pagination',
    },
});


/*
 * Masonry homepagina
 */

var grid = document.querySelector('.grid');
if (grid) {
    new Colcade(grid, {
        columns: '.grid-col',
        items: '.grid-item'
    });
}


/*
 * Gallery lightbox
 */

GLightbox({
    selector: '[data-glightbox]',
    touchNavigation: true,
    loop: true,
});


/*
 * Mobile menu trigger
 */

let body = $('body');
let mobileNav = $('.mobile-navigation');
$('.hamburger').on('click', function () {
    body.toggleClass('is-locked');
    $(this).toggleClass('is-active');
    mobileNav.toggleClass('is-active');
});


/*
 * Form validation
 */

import {FormValidation} from './FormValidation';

const forms = document.getElementsByClassName('form-validation');
if (forms.length > 0) {
    forEach(forms, function (form) {
        new FormValidation($(form), {
            allowUrlOverwrite: false,
            loading: 'Laden...',
            button: form.querySelector('[type=submit]'),
            inputGroup: 'form__input',
            messages: {
                required: ''
            },
            afterSubmit: function () {
                $('#alert').show();
                $(form).hide();
            }
        });
    });
}
